// The working week runs Friday to Thursday. Dates are local calendar dates (YYYY-MM-DD): going through
// toISOString() would use the UTC date, which is the previous day in the first hours after midnight in Iraq.
const pad = (n) => String(n).padStart(2, "0");

const isoDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// The Friday that starts the week containing `now`.
export function currentWeekStart(now = new Date()) {
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  start.setDate(start.getDate() - ((start.getDay() + 2) % 7));
  return isoDate(start);
}

// Today's local calendar date as "YYYY-MM-DD".
export const todayIso = (now = new Date()) => isoDate(now);

// "YYYY-MM" of the month containing `now`.
export const currentMonth = (now = new Date()) => `${now.getFullYear()}-${pad(now.getMonth() + 1)}`;

// "YYYY-MM-DD" -> local Date, or null when it is not a real calendar date.
function parseIso(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || ""));
  if (!m) return null;
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return d.getMonth() === Number(m[2]) - 1 ? d : null;
}

// Weeks start on Friday: is this date a Friday?
export function isFriday(iso) {
  return parseIso(iso)?.getDay() === 5;
}

// The Friday on or before the given date, or "" for an invalid date.
export function fridayOnOrBefore(iso) {
  const d = parseIso(iso);
  if (!d) return "";
  d.setDate(d.getDate() - ((d.getDay() + 2) % 7));
  return isoDate(d);
}

// The date n days after the given "YYYY-MM-DD" (local calendar), or "" for an invalid date.
export function addDays(iso, n) {
  const d = parseIso(iso);
  if (!d) return "";
  d.setDate(d.getDate() + n);
  return isoDate(d);
}
